export default {
    manage_deleteContact_title: "Delete Contact",
    manage_deleteContacts_title: "Delete Contacts",
    manage_deleteContacts_description: "Are you sure you want to delete the Contacts?",
    manage_deleteContact_description: "Are you sure you want to delete this Contact?",
    manage_deleteContact_successMessage: "Contact deleted",
    manage_deleteContacts_successMessage: "Contacts deleted",
    manage_deleteContacts_are_in_use: "It is not possible to delete contacts in use",
}